import React from "react";

import ImageStore from "@/stores/ImageStore";

import styles from "./ImageCropOverlay.module.css";

/**
 * @typedef {typeof import("@/constants/DesignConstants.mjs").LAYOUTS} Layouts
 *
 * @param {Object} props
 * @param {Layouts[number]} props.layout
 * @param {() => void} props.onBackgroundClick
 */
const ImageCropOverlay = ({ layout, onBackgroundClick }) => {
  const { x, y, h, w, a } = ImageStore.getElementDimensions(layout).toJS();

  const dimensionVars = {
    "--dimensions-x": x,
    "--dimensions-y": y,
    "--dimensions-w": w,
    "--dimensions-h": h,
    "--dimensions-a": a,
  };

  return (
    <>
      <div className={styles.shield} id={`crop-overlay-bg-${layout}`} style={dimensionVars}>
        <div className={styles.hole} data-testid={`crop-overlay-hole-${layout}`} />
      </div>
      <svg
        className={styles.overlay}
        id={`crop-overlay-${layout}`}
        onClick={onBackgroundClick}
        style={dimensionVars}
      />
    </>
  );
};

export default ImageCropOverlay;
